import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
});

export const submitInquiry = (payload) => client.post("/inquiries", payload).then((r) => r.data);
export const subscribeNewsletter = (email) => client.post("/newsletter", { email }).then((r) => r.data);
export const fetchBlogPosts = (params = {}) => client.get("/blog/posts", { params }).then((r) => r.data);
export const fetchBlogCount = (category) =>
  client.get("/blog/posts/count", { params: category ? { category } : {} }).then((r) => r.data);
export const fetchBlogCategories = () => client.get("/blog/categories").then((r) => r.data);
export const fetchBlogPost = (slug) => client.get(`/blog/posts/${slug}`).then((r) => r.data);
export const fetchFaqs = (category) =>
  client.get("/faqs", { params: category ? { category } : {} }).then((r) => r.data);
export const fetchFaqCategories = () => client.get("/faqs/categories").then((r) => r.data);

export const CONTACT_INFO = {
  whatsapp: "+6281572361851",
  whatsappHref: "https://wa.me/6281572361851",
  email: "info@westjavatea.com",
  emailHref: "mailto:info@westjavatea.com",
  linkedin: "https://www.linkedin.com/company/pt-agrikultural-nusantara-perkasa/",
  mapsHref:
    "https://www.google.com/maps/search/?api=1&query=West+Java+Highlands+Indonesia",
  addressLine1: "West Java Highlands",
  addressLine2: "Indonesia",
};

export default client;
